/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';

import GetUsersForRole from '../../services/GetUsersForRole';
import ForwardTask from '../../services/ForwardTask';
import modelGet from '../../util/modelGet';
import { validateForm } from '../../util/ParsleyUtils';
import SpinnerView from '../SpinnerView';

import NewAssigneeSelectView from './NewAssigneeSelectView';
import './TaskReassignModalView.css';
import tmplTaskReassignModalView from './TaskReassignModalView.hbs';

const TaskReassignModalView = View.extend({
  template: tmplTaskReassignModalView,

  className: 'task-reassign-modal-view',

  ui: {
    reassignTaskForm: '.reassign-task-form',
    newAssigneeContainer: '.new-assignee-container',
    submit: '.submit',
  },

  regions: {
    newAssigneeContainer: '@ui.newAssigneeContainer',
  },

  events: {
    'click @ui.submit': 'onClickSubmit',
  },

  onRender() {
    this.showChildView(
      'newAssigneeContainer',
      new SpinnerView({
        spinner: {
          scale: '0.8',
        },
      })
    );
    const targetRole = this.model.get('targetRole');
    const assignee = modelGet(this.model, 'task.assignee');

    GetUsersForRole(targetRole).then((users) => {
      this.showChildView(
        'newAssigneeContainer',
        new NewAssigneeSelectView({
          model: new Backbone.Model({
            users,
            targetRole,
            assignee,
          }),
        })
      );
      this.ui.submit.prop('disabled', false);
    });
  },

  onClickSubmit(e) {
    e.preventDefault();
    validateForm(this.ui.reassignTaskForm).then(() => {
      const spinner = Ladda.create(this.ui.submit[0]);
      spinner.start();
      const formData = Syphon.serialize(this);
      formData.taskId = modelGet(this.model, 'task.taskId');
      ForwardTask(formData)
        .then(() => {
          // Reload page after task has been successfully reassigned.
          Backbone.history.loadUrl();
          this.triggerMethod('modal:close');
        })
        .catch(() => {
          this.triggerMethod('modal:close');
        });
    });
  },
});

export default TaskReassignModalView;
